export function toLocaleDigits(input, lang = 'en') {
  if (input == null) return '';
  const str = String(input);
  if (lang !== 'mr') return str;
  const map = {
    '0': '०',
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    ',': ',',
    '.': '.',
  };
  return str.replace(/[0-9]/g, (d) => map[d] || d);
}

export function formatPercent(value, lang = 'en', opts = { decimals: 0 }) {
  if (value == null) return '';
  const num = typeof value === 'number' ? value : parseFloat(String(value).replace(/[^0-9.-]+/g, ''));
  const decimals = opts.decimals ?? 0;
  const formatted = Number.isFinite(num) ? num.toFixed(decimals) : String(value);
  const localized = toLocaleDigits(formatted, lang);
  return `${localized}%`;
}
